import { convertRemToPixels } from "./convertRemToPx";

export function getCustomPropertyValueInPx(property: string) {
  return convertRemToPixels(getComputedStyle(document.body).getPropertyValue(property));
}
